(ns minorodata.components.spinner.core
  (:require
   [lucide-react :refer [Loader2]]
   [ui.typography :as typography]
   [ui.utils :refer [clsx]]))


(defn full-screen [{:keys [open]
                    :or   {open false}}]
  (when open
    [:div {:class "z-40! pt-40 bg-black/50 inset-0 absolute flex justify-center"}
     [:> Loader2 {:class "text-kleene-primary-v2 animate-spin" :size 60}]]))


(defn inline []
  [:> Loader2 {:class "text-kleene-primary-v2 animate-spin"}])


(defn inline-configurable [{:keys [color size class]
                            :or   {color "primary"
                                   size  25}}]

  [:> Loader2 {:class (clsx "text-kleene-primary-v2 animate-spin" class)
               :size size}])

(defn spinner-lucide [props]
  [:> Loader2 (-> props
                  (update :class #(clsx "text-kleene-primary-v2 animate-spin" %)))])

(defn with-text [{:keys [text]}]
  [:div {:class "flex flex-row gap-2 px-4 justify-center items-center py-4 h-full"}
   [inline-configurable {:size 14}]
   [typography/label (or text "Loading...")]])
